module.exports = __webpack_public_path__ + "static/media/Facebook.84d5e452.png";